export interface AiReportNavState {
  activeType: "competitor" | "funnel" | "fan_user"
  selectedMonth: string
  selectedCompetitorId?: number | null
}

export const aiReportNavKey = (accountId: number) => `aiReport:${accountId}`

export const writeAiReportNav = (accountId: number, state: AiReportNavState): void => {
  try { sessionStorage.setItem(aiReportNavKey(accountId), JSON.stringify(state)) } catch {}
}

export const readAiReportNav = (accountId: number): AiReportNavState | null => {
  try {
    const raw = sessionStorage.getItem(aiReportNavKey(accountId))
    if (!raw) return null
    return JSON.parse(raw) as AiReportNavState
  } catch {
    return null
  }
}
